export function storeUrl(value, store) {
    if (!value) return '';
    const url = new URL(value);
    const host = store === 'apple' ? 'apps.apple.com' : 'play.google.com';
    if (url.protocol !== 'https:' || url.hostname !== host || url.username || url.password || url.port
        || (store === 'google' && !url.pathname.startsWith('/store/apps/'))) {
        throw new Error(`Invalid ${store === 'apple' ? 'App Store' : 'Google Play'} URL.`);
    }
    return url.toString();
}

function escape(value) {
    return value.replace(/[&<>"']/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[character]));
}

export function inviteInstallLinks(appUrl, settings = {}) {
    const origin = new URL(appUrl);
    if (origin.protocol !== 'https:' || origin.username || origin.password) throw new Error('Invalid install-instructions origin.');
    const instructions = new URL('/install', origin);
    if (origin.pathname === '/portal' || origin.pathname.startsWith('/portal/')) instructions.searchParams.set('app', 'portal');
    const installUrl = instructions.toString();
    const apple = storeUrl(settings.app_store_url, 'apple');
    const google = storeUrl(settings.google_play_url, 'google');
    const stores = [
        ...(apple ? [['App Store', apple]] : []),
        ...(google ? [['Google Play', google]] : []),
    ];
    return {
        text: `To install the app on your phone, click here: ${installUrl}${stores.length
            ? `\nGet the native app: ${stores.map(([label, url]) => `${label}: ${url}`).join(' | ')}` : ''}`,
        html: `<p>To install the app on your phone, <a href="${escape(installUrl)}">click here</a>.</p>${stores.length
            ? `<p>Get the native app: ${stores.map(([label, url]) => `<a href="${escape(url)}">${label}</a>`).join(' | ')}</p>` : ''}`,
    };
}
